/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./footer.css";
import { AiFillTwitterCircle } from "react-icons/ai";
import { BsInstagram } from "react-icons/bs";
import { FaFacebookSquare } from "react-icons/fa";
const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Jaloliddin
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a href="https://facebook.com" target="_blank">
          <FaFacebookSquare />
        </a>
        <a href="https://instagrame.com" target="_blank">
          <BsInstagram />
        </a>
        <a href="https://twitter.com" target="_blank">
          <AiFillTwitterCircle />
        </a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Yusupov Jaloliddin 2022</small>
      </div>
    </footer>
  );
};

export default Footer;
